import { gql } from "@apollo/client";

export const GET_GESTION_CREDITICIA = gql`
query clienteCC( $idEvaluacion:Int!, $codCliente: String! ){
  clienteCC( idEvaluacion:$idEvaluacion, codCliente: $codCliente ) {
    idEstadoCrediticioNavigation{
      idEstadoCrediticio
    }
    autorizacionInmediata
    fechaEstadoCrediticio
    fechaNotificacionCrediticia
    idMotivoCrediticioNavigation{
      idMotivoResolucionCrediticia
    }
    idUsuarioAutorizadorNavigation{
      nombre
      apellido
    }
    observacionCrediticia
  }
}`;

export const adaptGestionCrediticia = (data) => ({
  idEstadoCrediticio: data?.clienteCC?.idEstadoCrediticioNavigation?.idEstadoCrediticio,
  autorizacionInmediata: data?.clienteCC?.autorizacionInmediata,
  fechaNotificacionCrediticia: data?.clienteCC?.fechaNotificacionCrediticia,
  idMotivoResolucionCrediticia: data?.clienteCC?.idMotivoCrediticioNavigation?.idMotivoResolucionCrediticia,
  fechaEstadoCrediticio: data?.clienteCC?.fechaEstadoCrediticio,
  usuarioAutorizador: data?.clienteCC?.idUsuarioAutorizadorNavigation ?
  `${data?.clienteCC?.idUsuarioAutorizadorNavigation?.nombre} ${data?.clienteCC?.idUsuarioAutorizadorNavigation?.apellido}` :
  null,
  observacionCrediticia: data?.clienteCC?.observacionCrediticia
});